import React from 'react';
import { Form, Input, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import PATH from '@/config/paths/PATH';
import AppForm from '@/components/AppForm';
import { useMutation } from '@tanstack/react-query';
import AppPageTitle from '@/components/AppPageTitle';
import { createBlockMsisdn } from '@/services/block.service';
import useFormSubmit from '@/hooks/useFormSubmit';

const MsisdnBlockCreate = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const msisdnBlockMutation = useMutation({
    mutationFn: createBlockMsisdn,
  });

  const handleOnSubmit = useFormSubmit(
    msisdnBlockMutation,
    (values) => ({
      ...values,
    }),
    {
      onOk: () => {
        navigate(PATH.MSISDN_BLOCK.ROOT, {
          replace: true,
        });
      },
    }
  );

  return (
    <div>
      <AppPageTitle title="Create Block MSIDSN" />
      <AppForm
        form={form}
        onSubmit={handleOnSubmit}
        targetPath={PATH.MSISDN_BLOCK.ROOT}
        submitButtonProps={{
          loading: msisdnBlockMutation.isPending,
          disabled: msisdnBlockMutation.isPending,
        }}
        disabled={msisdnBlockMutation.isPending}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="MSISDN"
              name="isdn"
              rules={[{ required: true, message: 'Please enter MSIDSN' }]}
            >
              <Input placeholder="Enter MSIDSN" />
            </Form.Item>
          </Col>
        </Row>
      </AppForm>
    </div>
  );
};

export default MsisdnBlockCreate;
